import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhoneInputComponent } from './phone-input.component';
import { SharedDirectivesModule } from '@directives/shared-directives.module';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  declarations: [PhoneInputComponent],
  imports: [
    CommonModule,
    SharedDirectivesModule,
    FormsModule,
    NgSelectModule
  ],
  exports: [
    PhoneInputComponent
  ]
})
export class PhoneInputModule { }
